module.exports = __webpack_public_path__ + "img/two-stap-illustration.e973d915.svg";